import {FC, ReactNode} from 'react'
import styles from './Tabs.scss'

interface Props {
  children: ReactNode
}

export const Tabs: FC<Props> = ({children}) => <div className={styles.tabs}>{children}</div>
